import moment from "moment";

export const formatClientFormCompletedDate = (value) => {
  if (!value) return "";
  const parsed = moment(value, "YYYY-MM-DD HH:mm:ss", true);
  return parsed.isValid() ? parsed.format("DD MMMM YYYY") : "";
};
